import { getLandingPageContent } from '@/services/content.service'
import { LandingPagesContent } from '@/types'
import {
  ActionContext, Store
} from 'vuex'

export enum Properties {
  Loading = 'loading',
  Exception = 'exception',
  Content = 'content',

  FetchContent = 'fetchContent',
}

interface LandingPageState {
  [Properties.Content]: LandingPagesContent;
  [Properties.Loading]: boolean;
  [Properties.Exception]: boolean;
}

export type VuexActionContext = ActionContext<LandingPageState, {}>

export const NAME_SPACE = 'landingPage'
const namespace = (s: string): string => `${NAME_SPACE}/${s}`

export const fetchContent = (store: Store<VuexActionContext>): Promise<void> => store.dispatch(namespace(Properties.FetchContent))
export const getLoading = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.Loading)]
export const getException = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.Exception)]
export const getContent = (store: Store<VuexActionContext>): LandingPagesContent => store.getters[namespace(Properties.Content)]

const landingPageStore = {
  namespaced: true,
  state: {
    [Properties.Content]: undefined,
    [Properties.Loading]: true,
    [Properties.Exception]: false
  },
  getters: {
    [Properties.Content]: (state: LandingPageState) => state[Properties.Content],
    [Properties.Exception]: (state: LandingPageState) => state[Properties.Exception],
    [Properties.Loading]: (state: LandingPageState) => state[Properties.Loading]
  },
  mutations: {
    setLoading: /* istanbul ignore next */ (state: LandingPageState, loading: boolean) => {
      state[Properties.Loading] = loading
    },
    setException: /* istanbul ignore next */ (state: LandingPageState, exception: boolean) => {
      state[Properties.Exception] = exception
    },
    setContent: /* istanbul ignore next */ (
      state: LandingPageState, content: LandingPagesContent
    ) => {
      state[Properties.Content] = content
    }
  },
  actions: {
    [Properties.FetchContent]: async ({ commit }: ActionContext<LandingPageState, {}>): Promise<void> => {
      commit('setException', false)
      try {
        const content = await getLandingPageContent()

        commit('setContent', content)
      } catch (err) {
        commit('setException', true)
      } finally {
        commit('setLoading', false)
      }
    }
  }
}

export default landingPageStore
